/* import __COLOCATED_TEMPLATE__ from './task-suggestions.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type ReportingChartService from 'embercom/services/reporting-chart-service';
import type Store from '@ember-data/store';
import { AsyncData } from 'embercom/resources/utils/async-data';
import { use } from 'ember-resources/util/function-resource';
import { fetchTaskSuggestions } from './task-suggestions/task-suggestions-data-resources';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';

interface Args {}

export default class TaskSuggestions extends Component<Args> {
  @service declare appService: AppService;
  @service declare reportingChartService: ReportingChartService;
  @service declare store: Store;

  @use taskSuggestionsResource = AsyncData<TaskSuggestion[]>(({ abortSignal }) => {
    return fetchTaskSuggestions(
      this.store,
      this.appService.app.id,
      this.reportingChartService.useSyntheticData,
      abortSignal,
    );
  });

  get serializedReport() {
    return {
      id: 'task-suggestions',
      date_range: {
        selection: 'past_12_weeks',
      },
    };
  }

  get taskSuggestions(): TaskSuggestion[] {
    let suggestions = this.taskSuggestionsResource.value || [];
    return [...suggestions];
  }

  get usingSyntheticData(): boolean {
    return this.reportingChartService.useSyntheticData;
  }

  get isLoading() {
    return this.taskSuggestionsResource.isLoading;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TaskSuggestions': typeof TaskSuggestions;
  }
}
